import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector,
    private translate: TranslateService,
    private router: Router) {}

  handleError(error: any) {
    const toastr: ToastrService = this.injector.get<ToastrService>(ToastrService);
    if (!(error instanceof HttpErrorResponse)) {
      error = error.rejection; // get the error object
    }
    if (error instanceof HttpErrorResponse) {
      error.message ? console.log(error.message) : console.log(error.toString());
      if (error.status === 403 || error.status === 401) {
          toastr.error(this.translate.instant('product.exception.unauthorized_user'));
          this.router.navigate(['403']);
      } else {
        try {
          const error_ = JSON.parse(error.error)
          toastr.error(this.translate.instant(`product.exception.${error_.exceptionKey}`));
        } catch (e) {
          if(error.status === 404) {
            toastr.error(this.translate.instant(`product.exception.404`));
          } else if(error.status === 503) {
            toastr.error(this.translate.instant(`product.exception.503`));
          } else {
            toastr.error(this.translate.instant(`product.exception.invalid_client_id`));
          }
        }
      }
    }
    console.error('Error from global error handler', error);
  }
}